import { c as _c } from "react/compiler-runtime";
import { Radio } from "@website/ui/radio";
import { useRadioGroup } from "@website/ui/radio-group/radio-group.hook";
import styles from "@website/ui/radio-group/radio-group.module.scss";
import { RadioGroupItemsWrapperType, RadioGroupPropertiesType } from "@website/ui/radio-group/radio-group.types";
import { SizeType } from "@website/ui/types";
import { FC } from "react";
export const RadioGroup: FC<RadioGroupPropertiesType> = properties => {
  const $ = _c(25);
  const {
    rootProps,
    radioProps
  } = useRadioGroup(properties);
  const {
    className,
    itemClassName,
    radioClassName,
    items,
    size,
    title,
    vertical,
    titleStyle,
    error,
    helperText,
    wrapItems: t0
  } = properties;
  const wrapItems = t0 === undefined ? false : t0;
  const t1 = `flex items-center ${wrapItems ? "flex-wrap !gap-0" : ""} ${vertical ? "flex-col" : "flex-row gap-5"} ${className ?? ""} ${styles["radio-group"]} ${error ? styles.error : ""}`;
  let t2;
  if ($[0] !== size || $[1] !== title || $[2] !== titleStyle) {
    t2 = title ? <p className={`${styles.title} ${titleStyle} ${size === SizeType.lg ? "text-xl" : size === SizeType.sm ? "text-base" : "text-lg"}`}>{title}</p> : null;
    $[0] = size;
    $[1] = title;
    $[2] = titleStyle;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== itemClassName || $[5] !== items || $[6] !== radioClassName || $[7] !== radioProps) {
    let t4;
    if ($[9] !== itemClassName || $[10] !== radioClassName || $[11] !== radioProps) {
      t4 = (item, index) => <Radio className={radioClassName} key={String(item.label)} labelClassName={itemClassName ?? itemClassName} {...radioProps[index]} />;
      $[9] = itemClassName;
      $[10] = radioClassName;
      $[11] = radioProps;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    t3 = items.map(t4);
    $[4] = itemClassName;
    $[5] = items;
    $[6] = radioClassName;
    $[7] = radioProps;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[13] !== t3 || $[14] !== wrapItems) {
    t4 = <ItemsWrapper wrapItems={wrapItems}>{t3}</ItemsWrapper>;
    $[13] = t3;
    $[14] = wrapItems;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== helperText) {
    t5 = helperText ? <div className={styles["helper-text"]}>{helperText}</div> : null;
    $[16] = helperText;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== error || $[19] !== rootProps || $[20] !== t1 || $[21] !== t2 || $[22] !== t4 || $[23] !== t5) {
    t6 = <div {...rootProps} className={t1} data-error={error}>{t2}{t4}{t5}</div>;
    $[18] = error;
    $[19] = rootProps;
    $[20] = t1;
    $[21] = t2;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  return t6;
};
const ItemsWrapper: FC<RadioGroupItemsWrapperType> = t0 => {
  const $ = _c(2);
  const {
    wrapItems,
    children
  } = t0;
  if (!wrapItems) {
    return children;
  }
  let t1;
  if ($[0] !== children) {
    t1 = <div className="flex items-center justify-start">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};